module.exports = __webpack_public_path__ + "static/img/Nathan-Buckley.a4ab381.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nathan-Buckley.jpg
// module id = lqyD
// module chunks = 1